import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { AppFormRequest } from '../../../../app-common/form-request/app-form-request';
import { environment } from '../../../../../../environments/environment';
import { InputType } from 'src/app/common/components/form-builder/form-builder.component';
import { RequestButtonComponent } from 'src/app/common/components/request-button/request-button.component';
import { build, list, pool } from 'src/app/common/classes/request-builder';
import { FormRequestTypes } from 'src/app/common/classes/form-request';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Utils } from 'src/app/common/utils';
import moment from 'moment';

import { EcorregimenModel } from 'src/app/models/tareas/ecorregimen.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import {
    ItemInterface,
    TypeAheadInterface,
} from '../../../../../common/components/form-builder/form-builder.component';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { FilteredValue } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { OptionsComponent } from 'src/app/common/components/upload-file/upload-file.component';

@Component({
    selector: 'app-ecorregimenes-form',
    standalone: false,
    templateUrl: './ecorregimenes-form.component.html',
    styleUrls: ['./ecorregimenes-form.component.scss'],
})
export class EcorregimenesFormComponent
    extends BaseForm<EcorregimenModel>
    implements OnInit {
    @ViewChild(RequestButtonComponent) requestButton =
        new RequestButtonComponent<EcorregimenModel>();

    tareas_maquinaria_malas_hierbas = list(
        ['...', null],
        'Abonar (Mecanica)',
        'Fangueo / Fresadora (Mecanica)',
        'Hacer Márgenes (Mecanica)',
        'Trailla (Mecanica)',
        'Láser (Mecanica)',
        'Cultivador (Mecanica)',
        'Rotovator (Mecanica)',
        'Multiapero (Mecanica)',
        'Abrir Boqueras (Escardaquímica)',
        'Bordoma (Escardaquímica)',
        'Transplantar (Escardaquímica)',
        'Escarda (Escardaquímica)',
        'Desbroce Cursos de Agua (Escardaquímica)',
        'Siega Orillas (Escardaquímica)',
        'Quemar Paja (Escardaquímica)',
    );

    tareas_maquinaria_palustre = list(
        ['...', null],
        'Abonar (Mecanica)',
        'Fangueo / Fresadora (Mecanica)',
        'Hacer Márgenes (Mecanica)',
        'Trailla (Mecanica)',
        'Láser (Mecanica)',
        'Cultivador (Mecanica)',
        'Rotovator (Mecanica)',
        'Multiapero (Mecanica)',
        'Abrir Boqueras (Escardaquímica)',
        'Bordoma (Escardaquímica)',
        'Transplantar (Escardaquímica)',
        'Escarda (Escardaquímica)',
        'Desbroce Cursos de Agua (Escardaquímica)',
        'Siega Orillas (Escardaquímica)',
        'Quemar Paja (Escardaquímica)',
    );

    showPalustre = false;

    listMaquinariasMalasHierbas: TypeAheadInterface<MaquinariaModel> = list(['...', null]);
    
    listMaquinariasPalustre: TypeAheadInterface<MaquinariaModel> = list(['...', null]);

    public formRequest = new AppFormRequest<EcorregimenModel>();

    public rol = StorageManager.getUser().rol;

    public appName = environment.appName;

    public hasClients = environment.features.hasClients;

    public showTareasFitoHoras = environment.features.showTareasFitoHoras;

    public tareasHorasTotales = environment.features.tareasHorasTotales;

    public userCanSeeClientes = environment.features.userCanSeeClientes
        ? true
        : this.rol === 'admin';

    public hasFincas = environment.features.hasFincas;

    public override model: EcorregimenModel = {};

    public tratamientosList = list(['...', null]);

    public unidadList = list(['...', null]);

    public listFincas: TypeAheadInterface<FincasModel> = list(['...', null]);

    public listSectores: TypeAheadInterface<SectorModel[]> = list(['...', null]);

    public listParcelas: TypeAheadInterface<ParcelasModel> = list(['...', null]);
    
    public formFields: ItemInterface<object>[] = [
        {
            field: 'id_finca',
            label: 'Finca',
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: this.listFincas,
            valuePrimaryKey: 'id',
            required: true,
        },
        {
            field: 'id_sector',
            label: 'Sector',
            inputType: { type: InputType.MULTISELECT },
            values: this.listSectores,
            valuePrimaryKey: 'id',
            multiSelect: true,
            filter: (it: { value: SectorModel }) => {
                if (this.listFincas.selected) {
                    return it.value.id_finca === (this.listFincas.selected.id ?? '');
                } else {
                    return false;
                }
            },
        },
        {
            field: 'id_parcelas',
            label: 'Parcela',
            inputType: { type: InputType.MULTISELECT },
            multiSelect: true,
            canSelectAll: true,
            values: this.listParcelas,
            valuePrimaryKey: 'id',
            filter: (it: { value: ParcelasModel }) => {
                if (it.value.activo?.toString() === '1') {
                    if (this.listSectores.selected && this.listSectores.selected.length > 0) {
                        return this.listSectores.selected
                            .map((sector: SectorModel) => sector.id)
                            .includes(it.value.id_sector ?? '');
                    } else if (this.listFincas.selected) {
                        return it.value.id_finca === (this.listFincas.selected.id ?? '');
                    }
                }
                return false;
            },
            required: true,
        },
        {
            field: 'fecha_entrada',
            label: 'Fecha Entrada Agua',
            inputType: { type: InputType.CALENDAR },
            visible: this.appName !== 'avafitogest'
        },
        {
            field: 'fecha_salida',
            label: 'Fecha Salida Agua',
            inputType: { type: InputType.CALENDAR },
            visible: this.appName !== 'avafitogest'
        },
        {
            field: 'fecha_seca_cultivo_agua',
            label: 'Fecha Seca Cultivo de Agua',
            inputType: { type: InputType.CALENDAR },
            visible: this.appName !== 'avafitogest'
        },
        {
            field: 'fecha_seca_arroz',
            label: 'Fecha Seca Arroz',
            inputType: { type: InputType.CALENDAR },
            visible: this.appName !== 'avafitogest'
        },
    ];

    public formFieldsRastrojo: ItemInterface<object>[] = [
        {
            field: 'fecha_recoleccion_rastrojo',
            label: 'Fecha Recolección',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'operacion_paja',
            label: 'Operación',
            inputType: { type: InputType.DROPDOWN },
            values: list(
                ['...', null],
                'Secado',
                'Quema',
                'Empaca',
                'Enterrado',
                'Retirada',
                'Otros'
            ),
        },
        {
            field: 'fecha_operacion',
            label: 'Fecha Operación',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'hora_inicio',
            label: 'Hora Inicio Quema',
            inputType: { type: InputType.TIME },
            visible: this.showTareasFitoHoras,
        },
        {
            field: 'hora_fin',
            label: 'Hora Fin Quema',
            inputType: { type: InputType.TIME },
            visible: this.showTareasFitoHoras,
        },
        {
            field: 'horas_totales',
            label: 'Horas',
            inputType: { type: InputType.ONLY_TEXT },
            visible: this.appName === 'agroleza',
        },
    ];

    formFieldsArroz: ItemInterface<object>[] = [
        {
            field: 'fecha_siembra',
            label: 'Fecha Siembra',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'dosis_siembra',
            label: 'Dosis Siembra (kg/ha)',
            inputType: { type: InputType.EDIT_NUMERIC },
            helpText:
                'Mínimo 115 kg/Ha',
            visible: environment.appName === 'avafitogest',
        },
        {
            field: 'fecha_recoleccion_arroz',
            label: 'Fecha Recolección',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'fecha_nivelacion',
            label: 'Fecha Nivelación',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'control_mecanico_vn',
            label:
                'Control mecánico de la Vegetación Natural Palustre próxima a cursos de agua ',
            inputType: { type: InputType.SWITCH },
        }
    ];

    formFieldsMalasHierbas: ItemInterface<object>[] = [
        {
            field: 'tareas_malashierbas',
            label: 'Tareas',
            inputType: { type: InputType.DROPDOWN },
            values: this.tareas_maquinaria_malas_hierbas,
        },
        {
            field: 'fecha_malashierbas',
            label: 'Fecha',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'id_maquinaria_malashierbas',
            label: 'Maquinaria',
            inputType: { type: InputType.DROPDOWN },
            values: this.listMaquinariasMalasHierbas,
            valuePrimaryKey: 'id',
            filter: (it: FilteredValue<MaquinariaModel>): boolean => it.value?.activo?.toString() === '1'
        },
        {
            field: 'observaciones_malashierbas',
            label: 'Observaciones',
            inputType: { type: InputType.EDIT_TEXTAREA },
            audio: true,
        }
    ];

    formFieldsPalustr: ItemInterface<object>[] = [
        {
            field: 'tareas_palustre',
            label: 'Tareas Palustre',
            inputType: { type: InputType.DROPDOWN },
            values: this.tareas_maquinaria_palustre,
        },
        {
            field: 'fecha_paluestre',
            label: 'Fecha Palustre',
            inputType: { type: InputType.CALENDAR },
        },
        {
            field: 'id_maquinaria_palustre',
            label: 'Maquinaria',
            inputType: { type: InputType.DROPDOWN },
            values: this.listMaquinariasPalustre,
            valuePrimaryKey: 'id',
            filter: (it: FilteredValue<MaquinariaModel>): boolean => it.value?.activo?.toString() === '1' 
        },
        {
            field: 'observaciones_palustre',
            label: 'Observaciones',
            inputType: { type: InputType.EDIT_TEXTAREA },
            audio: true,
        }
    ];

    requestType: FormRequestTypes = 0;

    showDialogUploadFile = false;

    optionsUploadFile: OptionsComponent = {
        name: 'u_' + (environment.features.hasClients ? StorageManager.getClient().id : StorageManager.getUser().id),
        directory: 'agroambientales',
        multiple: false,
        accept: '.pdf',
        maxFileSize: 2000000,
        mode: 'advanced',
        uploaded: this.model.adjunto_guia ? true : false,
        uploadedFilesNames: [],
        url: environment.serverUrl + 'ws/index.php?p1=upload&p2=upload_file&folder=agroambientales',
        uploadFunction: this.uploadFile.bind(this)
    };

    handleNamesFilesOutput(event: string): void {
        this.model.adjunto_guia = event;   
    }

    handleEventUpload(event: { originalEvent: any; files: File[]; }): void {
        if(event.files.length > 0){
            this.model.adjunto_guia = event.files.map(file => file.name).join(', ');
        }
    }

    constructor(
        public override dashboard: DashboardService,
        public tareasApi: TareasApiService,
        public trabajadoresApi: TrabajadoresApiService,
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService
    ) {
        super(
            route,
            router,
            dashboard,
            tareasApi.ecorregimenes.PUT,
            tareasApi.ecorregimenes.POST,
            'tareas-ecorregimenes',
            `Editar Tarea ${environment.features.moduleNameEcorregimenesOrAgroAmbiental[1]}`,
            `Realizar Tarea ${environment.features.moduleNameEcorregimenesOrAgroAmbiental[1]}`,
            `Duplicar Tarea ${environment.features.moduleNameEcorregimenesOrAgroAmbiental[1]}`
        );
    }

    ngOnInit(): void {
        this.initFormData();
        this.expandFormRequest();

        this.formRequest
            .setType(this.getType())
            .setModel(this.model)
            .setRegisterId(this.getRegisterId())
            .setGetRequest(this.tareasApi.ecorregimenes.GET)
            .setPostRequest(this.tareasApi.ecorregimenes.POST)
            .setPutRequest(this.tareasApi.ecorregimenes.PUT)
            .setFormFields(Array.prototype.concat(this.formFields))
            .setFieldsToSend(
                ['id']
                    .concat(this.formFields.map((it) => it.field ?? ''))
                    .concat(this.formFieldsRastrojo.map((it) => it.field ?? ''))
                    .concat(this.formFieldsArroz.map((it) => it.field ?? ''))
                    .concat(this.formFieldsMalasHierbas.map((it) => it.field ?? ''))
                    .concat(this.formFieldsPalustr.map((it) => it.field ?? ''))
            );

        this.formRequest.load();
        this.softInit(this.getType());

        this.formRequest.afterLoad(() => {
            this.model.control_mecanico_vn = [1, '1', true, 'true'].includes(this.model.control_mecanico_vn ?? '');

            this.tareas_maquinaria_malas_hierbas.selected = this.tareas_maquinaria_malas_hierbas.filtered.find(
                (t) => t.value === 'Fangueo / Fresadora'
            );
            this.tareas_maquinaria_palustre.selected = this.tareas_maquinaria_palustre.filtered.find(
                (t) => t.value === 'Fangueo / Fresadora'
            );
        });
    }

    formChanges(tag: string) {
        if (tag === 'aplica_fertirrigacion') {
            if (!this.model.aplica_fertirrigacion) {
                this.model.dosis_n_nitrico = '';
                this.model.dosis_p = '';
                this.model.fecha = null;
            }
        }
        if (environment.features.tareasHorasTotales) {
            if (this.model.hora_inicio != null && this.model.hora_fin != null) {
                let horaFin = moment(this.model.hora_fin).format('HH:mm');
                let horaInicio = moment(this.model.hora_inicio).format('HH:mm');
                const timeFormat = new RegExp('^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$');

                if (!timeFormat.test(horaInicio)) {
                    horaInicio = this.model.hora_inicio;
                }

                if (!timeFormat.test(horaFin)) {
                    horaFin = this.model.hora_fin;
                }

                const diferencia = this.formatoHorasMinutos(horaInicio, horaFin);

                this.model.horas_totales = diferencia;
            } else {
                this.model.horas_totales = '';
            }
        }

        if (tag === 'control_mecanico_vn') {
            this.showPalustre = !this.showPalustre;
        }
    }

    formatoHorasMinutos(horaEntrada: string, horaSalida: string) {
        let timeStr: string | string[] = horaEntrada;

        timeStr = timeStr.split(':');

        const h = timeStr[0] ?? '',
            m = timeStr[1] ?? '';

        const newTime = moment(horaSalida + ' 2021-4-5')
            .subtract({ hours: +h, minutes: +m })
            .format('HH:mm');

        return newTime;
    }

    initFormData() {
        return pool(
            [
                build(this.fincasApi.fincasGET, this.listFincas, 'nombre'),
                build(this.fincasApi.sectoresGET, this.listSectores, 'nombre', true),
                build(
                    this.fincasApi.parcelasGET,
                    this.listParcelas,
                    this.appName === 'avafitogest' ? this.parcelaLabel : 'nombre',
                    true
                ),
                build(this.trabajadoresApi.maquinariaGET, this.listMaquinariasMalasHierbas,
                    (it: MaquinariaModel) => `${it.nombre  } ${it.empresa
                    ? ` - (${  it.empresa || '...'  })`
                    : ''}`, true),
                build(this.trabajadoresApi.maquinariaGET, this.listMaquinariasPalustre,
                    (it: MaquinariaModel) => `${it.nombre  } ${it.empresa
                    ? ` - (${  it.empresa || '...'  })`
                    : ''}`, true),
            ],
            () => {
                this.formRequest.update();
            }
        );
    }

    submit(): void {
        if (!this.formRequest.checkIfValid()) {
            this.requestButton.error = 'Hay campos obligatorios';
            console.log('Error');
            return;
        }

        if (this.model.fecha_inicio != null) {
            this.model.fecha_inicio = moment(this.model.fecha_inicio).format(
                'DD/MM/YYYY'
            );
        }
        if (this.model.fecha_fin_inundacion_invernal != null) {
            this.model.fecha_fin_inundacion_invernal = moment(
                this.model.fecha_fin_inundacion_invernal
            ).format('DD/MM/YYYY');
        }
        if (this.model.fecha_seca_cultivo_agua != null) {
            this.model.fecha_seca_cultivo_agua = moment(
                this.model.fecha_seca_cultivo_agua
            ).format('DD/MM/YYYY');
        }

        if (this.model.fecha_nivelacion != null) {
            this.model.fecha_nivelacion = moment(
                this.model.fecha_nivelacion
            ).format('DD/MM/YYYY');
        }

        if (this.model.fecha_siembra != null) {
            this.model.fecha_siembra = moment(
                this.model.fecha_siembra
            ).format('DD/MM/YYYY');
        }
        // La forma antigua para rellerafecha cuando este vacia
        // this.model.fecha_exp = moment(this.model.fecha_exp || new Date()).format('DD/MM/YYYY');
        this.formRequest.send();
    }

    uploadFile(event: { originalEvent: any; files: File[]; }): void {
        try {
            const response = JSON.parse(event.originalEvent.body);

            if (response.code === 200) {
                console.log('✅ Archivos subidos correctamente');
                
                this.showDialogUploadFile = false; 
            } else {
                console.error('❌ Error:', response.message);
            }
        } catch (e: any) {
            console.error('Error parsing response:', e);
        }
    }

    public getObservaciones(event: string): void {
        this.model.observaciones = event;
    }

    private expandFormRequest(): void {
        this.formRequest.beforeLoad((resolve) => {
            this.initFormData()
                .then(() => {
                    resolve(true);
                    return;
                })
                .catch((e: any) => {
                    console.log('catch en getPosition: ' + e);
                });
        });

        this.formRequest.beforeSend((resolve) => {
            this.model.fecha_entrada = this.model.fecha_entrada
                ? Utils.formatDate(this.model.fecha_entrada)
                : this.model.fecha_entrada ?? '';

            this.model.fecha_salida = this.model.fecha_salida
                ? Utils.formatDate(this.model.fecha_salida)
                : this.model.fecha_salida ?? '';

            this.model.fecha_seca_cultivo_agua = this.model.fecha_seca_cultivo_agua
                ? Utils.formatDate(this.model.fecha_seca_cultivo_agua)
                : this.model.fecha_seca_cultivo_agua ?? '';

            this.model.fecha_seca_arroz = this.model.fecha_seca_arroz
                ? Utils.formatDate(this.model.fecha_seca_arroz)
                : this.model.fecha_seca_arroz ?? '';

            this.model.fecha_recoleccion_rastrojo = this.model
                .fecha_recoleccion_rastrojo
                ? Utils.formatDate(this.model.fecha_recoleccion_rastrojo)
                : this.model.fecha_recoleccion_rastrojo ?? '';

            this.model.fecha_operacion = this.model.fecha_operacion
                ? Utils.formatDate(this.model.fecha_operacion)
                : this.model.fecha_operacion ?? '';

            this.model.fecha_operacion = this.model.fecha_operacion
                ? Utils.formatDate(this.model.fecha_operacion)
                : this.model.fecha_operacion ?? '';

            this.model.fecha_recoleccion_arroz = this.model.fecha_recoleccion_arroz
                ? Utils.formatDate(this.model.fecha_recoleccion_arroz)
                : this.model.fecha_recoleccion_arroz ?? '';

            this.model.fecha_seca_inicio_intermitente = this.model.fecha_seca_inicio_intermitente
                ? Utils.formatDate(this.model.fecha_seca_inicio_intermitente)
                : this.model.fecha_seca_inicio_intermitente ?? '';

            this.model.fecha_seca_fin_intermitente = this.model.fecha_seca_fin_intermitente
                ? Utils.formatDate(this.model.fecha_seca_fin_intermitente)
                : this.model.fecha_seca_fin_intermitente ?? '';

            this.model.fecha_paluestre = this.model.fecha_paluestre
                ? Utils.formatDate(this.model.fecha_paluestre)
                : this.model.fecha_paluestre ?? '';

            this.model.fecha_malashierbas = this.model.fecha_malashierbas
                ? Utils.formatDate(this.model.fecha_malashierbas)
                : this.model.fecha_malashierbas ?? '';

            this.model.fecha_nivelacion = this.model.fecha_nivelacion
                ? Utils.formatDate(this.model.fecha_nivelacion)
                : this.model.fecha_nivelacion ?? '';

            this.model.fecha_siembra = this.model.fecha_siembra
                ? Utils.formatDate(this.model.fecha_siembra)
                : this.model.fecha_siembra ?? '';

                
            if (StorageManager.getUser().tipo === 'comunero') {
                this.model.id_cliente = StorageManager.getUser().id_cliente ?? '';
            } else {
                const clientId = StorageManager.getClient()?.id ?? '';
                const clientIdFromForm = this.model.id_cliente;

                this.model.id_cliente = clientIdFromForm ?? clientId ?? '';
            }

            const userId = StorageManager.getUser().id;
            const userIdFromForm = this.model.id_usuario;

            this.model.id_usuario = userIdFromForm ?? userId ?? '';

            /**
             * Actualiza las horas de inicio y fin en el modelo si la entrada es válida.
             * Este fragmento de código verifica y formatea las horas de inicio y fin del objeto 'model' en formato 'HH:mm'.
             *
             * @param {string} this.model.hora_inicio - Hora de inicio a verificar y formatear.
             * @param {string} this.model.hora_fin - Hora de fin a verificar y formatear.
             */

            if (this.showTareasFitoHoras) {
                if (
                    this.model.hora_inicio &&
                    moment(this.model.hora_inicio).isValid()
                ) {
                    this.model.hora_inicio = moment(this.model.hora_inicio).format(
                        'HH:mm'
                    );
                }
                if (this.model.hora_fin && moment(this.model.hora_fin).isValid()) {
                    this.model.hora_fin = moment(this.model.hora_fin).format('HH:mm');
                }
            }
            resolve(true);
        });

        this.formRequest.afterFinish((resolve) => {
            if (this.getType() === FormRequestTypes.DUPLICATE) {
                setTimeout(() => {
                    window.location.reload();
                }, 200);
            }
            resolve(true);
        });
    }

    private parcelaLabel = (p: ParcelasModel) => {
        const nombre = (p.nombre ?? '').toString().trim();

        const pol = (p.poligono ?? '').toString().trim();
        const num = (p.numero ?? '').toString().trim();   // "parcela" SIGPAC
        const rec = (p.recinto ?? '').toString().trim();
        const codigos = [pol, num, rec].filter(Boolean).join('-'); // ej: 12-345-A

        const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
        const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
        const supFmt = supNum.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        const uds = environment.features.textoSuperficie || 'ha';

        const derecha = [codigos || undefined, `${supFmt} ${uds}`].filter(Boolean).join(' · ');
        return [nombre, derecha].filter(Boolean).join(' — ');
    };
}
